import "./ArrEdit.css";

import WWTabs from "../../components/WWTabs/WWTabs";
import { FldDefList } from "../../manage2/TableDesign/TableDesign";
import WWAccordion from "../../components/WWAccordion/WWAccordion";
import { useState } from "react";
import { useForm } from "react-hook-form";

// export default function({itemTpl, fldVal:fldValIn, forms, path}){
export default function({fldName, form, fldDef, opts, fldVal:fldValIn}){
    const [fldVal, setFldVal] = useState(fldValIn || []);

    return <div className="my-3">
        <button type="button" className="btn btn-sm btn-primary"
            title="add field"
            onClick={evt=>{
                // const newFldName = prompt("input new field name:");
                // if(!newFldName)return;
                // if(fldVal[newFldName]){
                //     alert('field exists.')
                //     return;
                // }
                // fldVal = fldVal || {};
                // fldVal[newFldName] = {};
                // setTblDef({...tblDef});
            }}
        >+</button>
        {/* <WWAccordion
            itemDefs={fldVal.map((itemVal, itemIdx)=>{
                const fldDef = (fldVal || {})[fldName] || {};
                const FldDefEditReady = CompFldDefEdits[fldName] || (({})=><FldDefEdit
                    fldName={fldName}
                    fldDef={{}}
                    form={form}
                    defaultFlds={{
                        test: {}
                    }}
                ></FldDefEdit>);
                return {
                    CaptionComp: ({})=><div
                        className="form-control me-3"
                    >
                        {fldIdx+1}. {fldName} ({fldDef.type||'input'})
                        <span className="btn btn-sm btn-primary ms-3 float-end"
                            onClick={evt=>{
                                const newTblDef = {...tblDef};
                                newTblDef.inputSettings = {...(newTblDef.inputSettings || {})};
                                delete newTblDef.inputSettings[fldName];
                                setTblDef(newTblDef);
                            }}
                        >X</span>
                    </div>,
                    Content: ({})=><FldDefEditReady></FldDefEditReady>
                };
            })}
        ></WWAccordion> */}
        {/* {
            Object.keys(fldVal || {}).map(fldName=>{
                // const FldEditWgt = getEditWgt('input');
                const fldDef = (fldVal || {})[fldName] || {};
                return <div 
                    key={fldName}
                    className="row mb-3"
                >
                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">{fldDef.caption || fldName}</label>
                    <div className="col-sm-10">
                        <FldDefEdit
                            fldName={fldName}
                            form={form}
                            fldDef={fldDef}                                            
                        >
                            
                        </FldDefEdit>
                    </div>
                </div>;
            })
        } */}
    </div>;
}
